import { render } from "./BottomFooter.vue?vue&type=template&id=0bffcde8&scoped=true"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"

import "./BottomFooter.vue?vue&type=style&index=0&id=0bffcde8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bffcde8"]])

export default __exports__